import { useCallback, useState } from 'react';

export const useStepNavigation = (totalSteps: number) => {
  const [currentStep, setCurrentStep] = useState<number>(1);

  const next = useCallback(() => {
    setCurrentStep((s) => Math.min(s + 1, totalSteps));
  }, [totalSteps]);

  const back = useCallback(() => {
    setCurrentStep((s) => Math.max(s - 1, 1));
  }, []);

  const goTo = useCallback((step: number) => {
    setCurrentStep(step);
  }, []);

  return {
    currentStep,
    totalSteps,
    isFirst: currentStep === 1,
    isLast: currentStep === totalSteps,
    next,
    back,
    goTo,
  };
};
